﻿'use strict';

var eventing = require('widget/scripts/lib/commons/events/eventing.js');

module.exports = function onEvent(event, listener) {
    var widget = this;
    eventing.on(widget, event, listener);
    return widget;
};




//////////////////
// WEBPACK FOOTER
// ./src/widget/scripts/lib/api/onEvent.js
// module id = 16
// module chunks = 0 1